import { useAnalytics } from '@/app/utils/useAnalytics';
import {
  Alignment,
  CmsCtaColour,
  LinkStyle,
  ctaColourToButtonVariant,
} from '@/cmsComponents/constants';
import SharedButton from '@/components/Button';
import cx from 'classnames';
import React from 'react';

import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import styles from './style.module.scss';

export interface LinkElementProps {
  linkText?: string;
  link: string;
  linkStyle?: LinkStyle;
  align?: Alignment;
  buttonClassName?: string;
  trackAction?: string;
  // When set, button-style links render as the shared (V3) Button in this colour.
  ctaColour?: CmsCtaColour;
  ctaClassName?: string;
}

export const LinkElement = ({
  linkText,
  link,
  linkStyle,
  align = Alignment.Center,
  buttonClassName,
  trackAction,
  ctaColour,
  ctaClassName,
}: LinkElementProps) => {
  const track = useAnalytics();

  if (ctaColour && linkStyle !== LinkStyle.HyperLink) {
    return (
      <div className={cx(styles.ctaContainer, styles[align])}>
        <SharedButton
          href={link}
          colorVariant={ctaColourToButtonVariant[ctaColour]}
          className={cx(styles.cta, ctaClassName)}
          trackFunction={eventProps =>
            track('Click', { ...eventProps, action: trackAction ?? 'CMS Button Click' })
          }
        >
          {linkText}
        </SharedButton>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {linkStyle === LinkStyle.HyperLink ? (
        <div className={styles[align]}>
          <Button href={link} className={styles.hyperLink}>
            <span>{linkText}</span>
            <ArrowForwardIcon />
          </Button>
        </div>
      ) : (
        <div className={styles[align]}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() =>
              track('Click', {
                action: trackAction ?? 'CMS Button Click',
                'element text': linkText ?? '',
                'element type': 'button',
              })
            }
            href={link}
            className={cx(styles.button, styles[linkStyle || 'Button'], buttonClassName)}
          >
            <span className={styles.linkText}>{linkText}</span>
          </Button>
        </div>
      )}
    </div>
  );
};
